export default __webpack_public_path__ + "static/media/nectar_b_shimmering.5a819877.png";